import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: `${_vm.modeClass} img-anchor-container`
  }, [_c('canvas', {
    ref: "canvas",
    staticClass: "canvas",
    on: {
      "mousedown": _vm.onDragStart,
      "mousemove": _vm.onDrag,
      "mouseleave": _vm.onDragEnd,
      "mouseout": _vm.onDragEnd,
      "mouseup": _vm.onDragEnd,
      "click": _vm.onCanvasClick
    }
  }), _c('div', {
    staticClass: "controls"
  }, [_c(VBtn, {
    class: `v-btn-zoom mx-1 v-btn--rounded bg-rounded-button-primary`,
    attrs: {
      "color": _vm.color,
      "disabled": _vm.zoom === _vm.minZoomFactor,
      "icon": "",
      "info": "",
      "text": ""
    },
    on: {
      "click": _vm.zoomOut
    }
  }, [_c(VIcon, {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("fa fa-search-minus")])], 1), _c(VBtn, {
    class: `v-btn-zoom mx-1 v-btn--rounded bg-rounded-button-primary`,
    attrs: {
      "color": _vm.color,
      "disabled": _vm.zoom === _vm.maxZoomFactor,
      "icon": "",
      "info": "",
      "text": ""
    },
    on: {
      "click": _vm.zoomIn
    }
  }, [_c(VIcon, {
    attrs: {
      "small": "",
      "dark": ""
    }
  }, [_vm._v("fa fa-search-plus")])], 1)], 1), _vm.anchor1.visible ? _c('core-dtwin-map-overlay-wizard-image-anchor-marker', {
    ref: "anchor1",
    attrs: {
      "position": _vm.anchor1.displayPosition,
      "color": "red"
    },
    on: {
      "moved-anchor": _vm.anchor1Moved
    }
  }) : _vm._e(), _vm.anchor2.visible ? _c('core-dtwin-map-overlay-wizard-image-anchor-marker', {
    ref: "anchor2",
    attrs: {
      "position": _vm.anchor2.displayPosition,
      "color": "blue"
    },
    on: {
      "moved-anchor": _vm.anchor2Moved
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };